import modal from '@/utils/modal';
import CommentSectionModal from './CommentSectionModal';

export default function openCommentSectionModal (targetId) {
    const m = modal.create(CommentSectionModal, true, {
        props: {
            targetId,
        },
    });
    return m;
}